import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { checkIsAdmin } from "../../api/axiosApi";
import { errorToast } from "../../utils/toastNotify";

interface AdminRouteProps {
    children: React.ReactNode;
}

const AdminRoute = ({ children }: AdminRouteProps) => {
    const [isSuperAdmin, setIsSuperAdmin] = useState<boolean | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const checkAdminStatus = async () => {
            try {
                const res = await checkIsAdmin();
                if (res.data.is_super_admin === true) {
                    setIsSuperAdmin(true);
                } else {
                    setIsSuperAdmin(false);
                    errorToast("Access denied. Super admin privileges required.");
                    // Delay navigation to allow toast to display
                    setTimeout(() => {
                        navigate("/workbench");
                    }, 500);
                }
            } catch (error) {
                console.error("Error checking super admin status:", error);
                setIsSuperAdmin(false);
                errorToast("Unable to verify admin status.");
                // Delay navigation to allow toast to display
                setTimeout(() => {
                    navigate("/workbench");
                }, 500);
            }
        };
        checkAdminStatus();
    }, [navigate]);

    if (isSuperAdmin === null) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
                    <p className="mt-4 text-gray-600">Checking permissions...</p>
                </div>
            </div>
        );
    }

    if (!isSuperAdmin) {
        // Keep component mounted briefly to allow toast to render
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="text-center">
                    <p className="text-gray-600">Redirecting...</p>
                </div>
            </div>
        );
    }

    return <>{children}</>;
};

export default AdminRoute;
